import Box from '@mui/material/Box';

interface ISearchListGrid {
    searchEl: React.ReactNode;
    children?: React.ReactNode;
    hideSearch?: boolean;
}


const SearchListGrid = (props: ISearchListGrid) => {

    const { searchEl, children, hideSearch } = props;

    return (
        <>
            {!hideSearch &&
                <Box sx={{ padding: "0 0 10px 0", }}>
                    {searchEl}
                </Box>
            }
            <Box sx={{ padding: "10px 0", }}>
                {children}
            </Box>
        </>
    );

};

export default SearchListGrid;